module.exports = __webpack_public_path__ + "img/trip_edge_icon.3dac0b94.svg";